export default "__VITE_ASSET__BtrXWfgJ__"